module.exports = __webpack_public_path__ + "893cb67d3df1530756933cbf2a41ee8b.svg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/logos/soundway.svg
 ** module id = 438
 ** module chunks = 0
 **/